var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChronischeZiektes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 422 238",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chronische-ziektes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chronische-ziektes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chronische-zieken",
    transform: "translate(0.940000, 2.980000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thema",
    transform: "translate(0.000000, 8.750000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 357,
    y1: 21,
    x2: 417,
    y2: 21,
    id: "Path",
    stroke: "#678750",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 351,
    y: 5.59,
    width: 12,
    height: 204.91
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 312,
    y: 28.88,
    width: 12,
    height: 181.62
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 273,
    y: 72.65,
    width: 12,
    height: 137.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 234,
    y: 127.11,
    width: 12,
    height: 82.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 195,
    y: 168.59,
    width: 12,
    height: 41.91
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 156,
    y: 186.28,
    width: 12,
    height: 24.22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 117,
    y: 184.42,
    width: 12,
    height: 26.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 78,
    y: 170.45,
    width: 12,
    height: 40.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 39,
    y: 183.49,
    width: 12,
    height: 27.01
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#678750",
    x: 0,
    y: 201.19,
    width: 12,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 366,
    y: 0,
    width: 12,
    height: 210.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 327,
    y: 21.42,
    width: 12,
    height: 189.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 288,
    y: 58.68,
    width: 12,
    height: 151.82
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 249,
    y: 109.41,
    width: 12,
    height: 100.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 210,
    y: 152.75,
    width: 12,
    height: 57.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 171,
    y: 169.52,
    width: 12,
    height: 40.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 132,
    y: 176.04,
    width: 12,
    height: 34.46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 93,
    y: 170.45,
    width: 12,
    height: 40.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 54,
    y: 186.72,
    width: 12,
    height: 23.29
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9B400",
    x: 15,
    y: 203.05,
    width: 12,
    height: 7.45
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 210,
    x2: 378,
    y2: 210,
    id: "Path",
    stroke: "#678750"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tekst",
    transform: "translate(4.140000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "156.16 187.79 155.05 188.77 155.05 187.87 156.16 186.91 156.98 186.91 156.98 192.6 156.16 192.6 156.16 187.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "159.39 187.79 158.28 188.77 158.28 187.87 159.39 186.91 160.21 186.91 160.21 192.6 159.39 192.6 159.39 187.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "170.58 170.79 169.47 171.77 169.47 170.87 170.58 169.91 171.4 169.91 171.4 175.6 170.58 175.6 170.58 170.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72,173.99 C172.72,173.31 173.1,172.9 173.5,172.66 C173.13,172.44 172.81,172.04 172.81,171.44 C172.81,170.49 173.54,169.86 174.47,169.86 C175.4,169.86 176.13,170.48 176.13,171.44 C176.13,172.04 175.81,172.44 175.44,172.66 C175.84,172.9 176.22,173.32 176.22,173.99 C176.22,175.02 175.44,175.65 174.46,175.65 C173.48,175.65 172.71,175.03 172.71,173.99 L172.72,173.99 Z M175.41,173.97 C175.41,173.44 175,173.02 174.47,173.02 C173.94,173.02 173.53,173.44 173.53,173.97 C173.53,174.5 173.94,174.91 174.47,174.91 C175,174.91 175.41,174.49 175.41,173.97 Z M175.32,171.45 C175.32,170.95 174.97,170.58 174.47,170.58 C173.97,170.58 173.63,170.96 173.63,171.45 C173.63,171.94 173.97,172.31 174.47,172.31 C174.97,172.31 175.32,171.95 175.32,171.45 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "2.3 206.74 0 206.74 0 205.98 2.01 201.9 2.89 201.9 0.89 205.98 2.31 205.98 2.31 204.65 3.1 204.65 3.1 205.98 3.71 205.98 3.71 206.74 3.1 206.74 3.1 207.6 2.31 207.6 2.31 206.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.05,209.05 L15.87,209.05 C15.9,209.66 16.33,209.91 16.8,209.91 C17.33,209.91 17.73,209.57 17.73,208.97 C17.73,208.37 17.42,208.04 16.78,208.04 L16.64,208.04 L16.64,207.33 L16.78,207.33 C17.37,207.33 17.64,206.99 17.64,206.47 C17.64,205.89 17.26,205.59 16.8,205.59 C16.3,205.59 15.98,205.9 15.94,206.41 L15.12,206.41 C15.17,205.44 15.88,204.86 16.79,204.86 C17.76,204.86 18.44,205.51 18.44,206.45 C18.44,207.06 18.17,207.44 17.73,207.66 C18.22,207.88 18.53,208.29 18.53,208.99 C18.53,210.09 17.74,210.65 16.79,210.65 C15.84,210.65 15.08,210.16 15.05,209.05 L15.05,209.05 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "38.74 182.64 37.63 183.62 37.63 182.72 38.74 181.76 39.56 181.76 39.56 187.45 38.74 187.45 38.74 182.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.78,186.72 L42.97,184.06 C43.19,183.8 43.27,183.59 43.27,183.3 C43.27,182.79 42.97,182.44 42.44,182.44 C42.01,182.44 41.6,182.68 41.6,183.32 L40.78,183.32 C40.78,182.35 41.47,181.71 42.44,181.71 C43.41,181.71 44.09,182.33 44.09,183.31 C44.09,183.81 43.91,184.11 43.55,184.54 L41.77,186.72 L44.09,186.72 L44.09,187.45 L40.78,187.45 L40.78,186.72 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "53.64 187.79 52.53 188.77 52.53 187.87 53.64 186.91 54.46 186.91 54.46 192.6 53.64 192.6 53.64 187.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.83,191.02 L55.83,188.49 C55.83,187.47 56.57,186.86 57.47,186.86 C58.37,186.86 59.12,187.48 59.12,188.49 L59.12,191.02 C59.12,192.04 58.38,192.65 57.47,192.65 C56.56,192.65 55.83,192.03 55.83,191.02 Z M58.3,191 L58.3,188.52 C58.3,187.98 57.99,187.59 57.47,187.59 C56.95,187.59 56.65,187.97 56.65,188.52 L56.65,191 C56.65,191.54 56.96,191.93 57.47,191.93 C57.98,191.93 58.3,191.55 58.3,191 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "77.58 169.79 76.47 170.77 76.47 169.87 77.58 168.91 78.4 168.91 78.4 174.6 77.58 174.6 77.58 169.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.72,172.99 C79.72,172.31 80.1,171.9 80.5,171.66 C80.13,171.44 79.81,171.04 79.81,170.44 C79.81,169.49 80.54,168.86 81.47,168.86 C82.4,168.86 83.13,169.48 83.13,170.44 C83.13,171.04 82.81,171.44 82.44,171.66 C82.84,171.9 83.22,172.32 83.22,172.99 C83.22,174.02 82.44,174.65 81.46,174.65 C80.48,174.65 79.71,174.03 79.71,172.99 L79.72,172.99 Z M82.41,172.97 C82.41,172.44 82,172.02 81.47,172.02 C80.94,172.02 80.53,172.44 80.53,172.97 C80.53,173.5 80.94,173.91 81.47,173.91 C82,173.91 82.41,173.49 82.41,172.97 Z M82.32,170.45 C82.32,169.95 81.97,169.58 81.47,169.58 C80.97,169.58 80.63,169.96 80.63,170.45 C80.63,170.94 80.97,171.31 81.47,171.31 C81.97,171.31 82.32,170.95 82.32,170.45 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "92.58 169.79 91.47 170.77 91.47 169.87 92.58 168.91 93.4 168.91 93.4 174.6 92.58 174.6 92.58 169.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,172.99 C94.72,172.31 95.1,171.9 95.5,171.66 C95.13,171.44 94.81,171.04 94.81,170.44 C94.81,169.49 95.54,168.86 96.47,168.86 C97.4,168.86 98.13,169.48 98.13,170.44 C98.13,171.04 97.81,171.44 97.44,171.66 C97.84,171.9 98.22,172.32 98.22,172.99 C98.22,174.02 97.44,174.65 96.46,174.65 C95.48,174.65 94.71,174.03 94.71,172.99 L94.72,172.99 Z M97.41,172.97 C97.41,172.44 97,172.02 96.47,172.02 C95.94,172.02 95.53,172.44 95.53,172.97 C95.53,173.5 95.94,173.91 96.47,173.91 C97,173.91 97.41,173.49 97.41,172.97 Z M97.32,170.45 C97.32,169.95 96.97,169.58 96.47,169.58 C95.97,169.58 95.63,169.96 95.63,170.45 C95.63,170.94 95.97,171.31 96.47,171.31 C96.97,171.31 97.32,170.95 97.32,170.45 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "116.74 184.79 115.63 185.77 115.63 184.87 116.74 183.91 117.56 183.91 117.56 189.6 116.74 189.6 116.74 184.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78,188.87 L120.97,186.21 C121.19,185.95 121.27,185.74 121.27,185.45 C121.27,184.94 120.97,184.59 120.44,184.59 C120.01,184.59 119.6,184.83 119.6,185.47 L118.78,185.47 C118.78,184.5 119.47,183.86 120.44,183.86 C121.41,183.86 122.09,184.48 122.09,185.46 C122.09,185.96 121.91,186.26 121.55,186.69 L119.77,188.87 L122.09,188.87 L122.09,189.6 L118.78,189.6 L118.78,188.87 L118.78,188.87 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "131.64 175.79 130.53 176.77 130.53 175.87 131.64 174.91 132.46 174.91 132.46 180.6 131.64 180.6 131.64 175.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.25,180.21 C133.95,179.91 133.85,179.53 133.82,179.12 L134.64,179.12 C134.7,179.62 134.96,179.91 135.47,179.91 C135.71,179.91 135.92,179.83 136.06,179.69 C136.3,179.45 136.33,179.07 136.33,178.69 C136.33,178.01 136.15,177.51 135.5,177.51 C135.04,177.51 134.78,177.74 134.69,178.02 L133.95,178.02 L133.95,174.91 L137.02,174.91 L137.02,175.64 L134.69,175.64 L134.69,177.14 C134.88,176.94 135.22,176.81 135.63,176.81 C136.08,176.81 136.42,176.95 136.65,177.18 C137.08,177.61 137.15,178.16 137.15,178.69 C137.15,179.3 137.09,179.79 136.67,180.2 C136.41,180.46 136.02,180.65 135.47,180.65 C134.92,180.65 134.5,180.46 134.25,180.21 L134.25,180.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "194.74 169.79 193.63 170.77 193.63 169.87 194.74 168.91 195.56 168.91 195.56 174.6 194.74 174.6 194.74 169.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.81,172.12 C198.65,172.21 198.47,172.24 198.28,172.24 C197.46,172.24 196.78,171.58 196.78,170.59 C196.78,169.54 197.48,168.85 198.46,168.85 C199.44,168.85 200.15,169.5 200.15,170.55 C200.15,170.94 200.05,171.3 199.75,171.91 L198.43,174.59 L197.56,174.59 L198.81,172.11 L198.81,172.12 Z M199.34,170.58 C199.34,169.96 198.99,169.59 198.48,169.59 C197.97,169.59 197.61,169.97 197.61,170.58 C197.61,171.14 197.94,171.56 198.48,171.56 C198.99,171.56 199.34,171.18 199.34,170.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,158.02 L210.32,155.36 C210.54,155.1 210.62,154.89 210.62,154.6 C210.62,154.09 210.32,153.74 209.79,153.74 C209.36,153.74 208.95,153.98 208.95,154.62 L208.13,154.62 C208.13,153.65 208.82,153.01 209.79,153.01 C210.76,153.01 211.44,153.63 211.44,154.61 C211.44,155.11 211.26,155.41 210.9,155.84 L209.12,158.02 L211.44,158.02 L211.44,158.75 L208.13,158.75 L208.13,158.02 L208.13,158.02 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.21,157.1 C212.21,156.71 212.31,156.35 212.61,155.74 L213.93,153.06 L214.8,153.06 L213.56,155.54 C213.71,155.45 213.9,155.42 214.08,155.42 C214.9,155.42 215.58,156.08 215.58,157.07 C215.58,158.12 214.89,158.81 213.9,158.81 C212.91,158.81 212.21,158.16 212.21,157.11 L212.21,157.1 Z M214.76,157.08 C214.76,156.52 214.43,156.1 213.89,156.1 C213.38,156.1 213.03,156.48 213.03,157.08 C213.03,157.68 213.38,158.07 213.89,158.07 C214.4,158.07 214.76,157.69 214.76,157.08 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.04,131.55 L232.86,131.55 C232.89,132.16 233.32,132.41 233.79,132.41 C234.32,132.41 234.72,132.07 234.72,131.47 C234.72,130.87 234.41,130.54 233.77,130.54 L233.63,130.54 L233.63,129.83 L233.77,129.83 C234.36,129.83 234.63,129.49 234.63,128.97 C234.63,128.39 234.25,128.09 233.79,128.09 C233.29,128.09 232.97,128.4 232.93,128.91 L232.11,128.91 C232.16,127.94 232.87,127.36 233.78,127.36 C234.75,127.36 235.43,128.01 235.43,128.95 C235.43,129.56 235.16,129.94 234.72,130.16 C235.21,130.38 235.52,130.79 235.52,131.49 C235.52,132.59 234.73,133.15 233.78,133.15 C232.83,133.15 232.07,132.66 232.04,131.55 L232.04,131.55 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "238.8 128.14 237.07 128.14 237.07 129.04 236.29 129.04 236.29 127.42 239.68 127.42 239.68 128.15 237.78 133.11 236.9 133.11 238.81 128.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "249.14 114.25 246.84 114.25 246.84 113.49 248.85 109.41 249.73 109.41 247.73 113.49 249.15 113.49 249.15 112.16 249.94 112.16 249.94 113.49 250.55 113.49 250.55 114.25 249.94 114.25 249.94 115.11 249.15 115.11 249.15 114.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "253.47 114.25 251.17 114.25 251.17 113.49 253.18 109.41 254.06 109.41 252.06 113.49 253.48 113.49 253.48 112.16 254.27 112.16 254.27 113.49 254.88 113.49 254.88 114.25 254.27 114.25 254.27 115.11 253.48 115.11 253.48 114.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.56,76.94 C271.56,76.55 271.66,76.19 271.96,75.58 L273.28,72.9 L274.15,72.9 L272.91,75.38 C273.06,75.29 273.25,75.26 273.43,75.26 C274.25,75.26 274.93,75.92 274.93,76.91 C274.93,77.96 274.24,78.65 273.25,78.65 C272.26,78.65 271.56,78 271.56,76.95 L271.56,76.94 Z M274.11,76.92 C274.11,76.36 273.78,75.94 273.24,75.94 C272.73,75.94 272.38,76.32 272.38,76.92 C272.38,77.52 272.73,77.91 273.24,77.91 C273.75,77.91 274.11,77.53 274.11,76.92 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "276.8 73.79 275.69 74.77 275.69 73.87 276.8 72.91 277.62 72.91 277.62 78.6 276.8 78.6 276.8 73.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.17,62.94 C286.17,62.55 286.27,62.19 286.57,61.58 L287.89,58.9 L288.76,58.9 L287.52,61.38 C287.67,61.29 287.86,61.26 288.04,61.26 C288.86,61.26 289.54,61.92 289.54,62.91 C289.54,63.96 288.85,64.65 287.86,64.65 C286.87,64.65 286.17,64 286.17,62.95 L286.17,62.94 Z M288.72,62.92 C288.72,62.36 288.39,61.94 287.85,61.94 C287.34,61.94 286.99,62.32 286.99,62.92 C286.99,63.52 287.34,63.91 287.85,63.91 C288.36,63.91 288.72,63.53 288.72,62.92 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "292.74 59.64 291 59.64 291 60.54 290.22 60.54 290.22 58.92 293.61 58.92 293.61 59.65 291.71 64.61 290.83 64.61 292.74 59.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.97,33.14 C309.97,32.46 310.35,32.05 310.75,31.81 C310.38,31.59 310.06,31.19 310.06,30.59 C310.06,29.64 310.79,29.01 311.72,29.01 C312.65,29.01 313.38,29.63 313.38,30.59 C313.38,31.19 313.06,31.59 312.69,31.81 C313.09,32.05 313.47,32.47 313.47,33.14 C313.47,34.17 312.69,34.8 311.71,34.8 C310.73,34.8 309.96,34.18 309.96,33.14 L309.97,33.14 Z M312.66,33.12 C312.66,32.59 312.25,32.17 311.72,32.17 C311.19,32.17 310.78,32.59 310.78,33.12 C310.78,33.65 311.19,34.06 311.72,34.06 C312.25,34.06 312.66,33.64 312.66,33.12 Z M312.57,30.6 C312.57,30.1 312.22,29.73 311.72,29.73 C311.22,29.73 310.88,30.11 310.88,30.6 C310.88,31.09 311.22,31.46 311.72,31.46 C312.22,31.46 312.57,31.1 312.57,30.6 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.41,33.17 L314.41,30.64 C314.41,29.62 315.15,29.01 316.05,29.01 C316.95,29.01 317.7,29.63 317.7,30.64 L317.7,33.17 C317.7,34.19 316.96,34.8 316.05,34.8 C315.14,34.8 314.41,34.18 314.41,33.17 Z M316.88,33.15 L316.88,30.67 C316.88,30.13 316.57,29.74 316.05,29.74 C315.53,29.74 315.23,30.12 315.23,30.67 L315.23,33.15 C315.23,33.69 315.54,34.08 316.05,34.08 C316.56,34.08 316.88,33.7 316.88,33.15 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.94,25.14 C324.94,24.46 325.32,24.05 325.72,23.81 C325.35,23.59 325.03,23.19 325.03,22.59 C325.03,21.64 325.76,21.01 326.69,21.01 C327.62,21.01 328.35,21.63 328.35,22.59 C328.35,23.19 328.03,23.59 327.66,23.81 C328.06,24.05 328.44,24.47 328.44,25.14 C328.44,26.17 327.66,26.8 326.68,26.8 C325.7,26.8 324.93,26.18 324.93,25.14 L324.94,25.14 Z M327.63,25.12 C327.63,24.59 327.22,24.17 326.69,24.17 C326.16,24.17 325.75,24.59 325.75,25.12 C325.75,25.65 326.16,26.06 326.69,26.06 C327.22,26.06 327.63,25.64 327.63,25.12 Z M327.54,22.6 C327.54,22.1 327.19,21.73 326.69,21.73 C326.19,21.73 325.85,22.11 325.85,22.6 C325.85,23.09 326.19,23.46 326.69,23.46 C327.19,23.46 327.54,23.1 327.54,22.6 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "331.5 25.9 329.2 25.9 329.2 25.14 331.21 21.06 332.09 21.06 330.09 25.14 331.51 25.14 331.51 23.81 332.3 23.81 332.3 25.14 332.91 25.14 332.91 25.9 332.3 25.9 332.3 26.76 331.51 26.76 331.51 25.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.07,9.27 C350.91,9.36 350.73,9.39 350.54,9.39 C349.72,9.39 349.04,8.73 349.04,7.74 C349.04,6.69 349.74,6 350.72,6 C351.7,6 352.41,6.65 352.41,7.7 C352.41,8.09 352.31,8.45 352.01,9.06 L350.69,11.74 L349.82,11.74 L351.07,9.26 L351.07,9.27 Z M351.6,7.73 C351.6,7.11 351.25,6.74 350.74,6.74 C350.23,6.74 349.87,7.12 349.87,7.73 C349.87,8.29 350.2,8.71 350.74,8.71 C351.25,8.71 351.6,8.33 351.6,7.73 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.24,10.17 L353.24,7.64 C353.24,6.62 353.98,6.01 354.88,6.01 C355.78,6.01 356.53,6.63 356.53,7.64 L356.53,10.17 C356.53,11.19 355.79,11.8 354.88,11.8 C353.97,11.8 353.24,11.18 353.24,10.17 Z M355.71,10.15 L355.71,7.67 C355.71,7.13 355.4,6.74 354.88,6.74 C354.36,6.74 354.06,7.12 354.06,7.67 L354.06,10.15 C354.06,10.69 354.37,11.08 354.88,11.08 C355.39,11.08 355.71,10.7 355.71,10.15 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.11,3.27 C365.95,3.36 365.77,3.39 365.58,3.39 C364.76,3.39 364.08,2.73 364.08,1.74 C364.08,0.69 364.78,0 365.76,0 C366.74,0 367.45,0.65 367.45,1.7 C367.45,2.09 367.35,2.45 367.05,3.06 L365.73,5.74 L364.86,5.74 L366.11,3.26 L366.11,3.27 Z M366.64,1.73 C366.64,1.11 366.29,0.74 365.78,0.74 C365.27,0.74 364.91,1.12 364.91,1.73 C364.91,2.29 365.24,2.71 365.78,2.71 C366.29,2.71 366.64,2.33 366.64,1.73 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.08,4.2 L368.9,4.2 C368.93,4.81 369.36,5.06 369.83,5.06 C370.36,5.06 370.76,4.72 370.76,4.12 C370.76,3.52 370.45,3.19 369.81,3.19 L369.67,3.19 L369.67,2.48 L369.81,2.48 C370.4,2.48 370.67,2.14 370.67,1.62 C370.67,1.04 370.29,0.74 369.83,0.74 C369.33,0.74 369.01,1.05 368.97,1.56 L368.15,1.56 C368.2,0.59 368.91,0.01 369.82,0.01 C370.79,0.01 371.47,0.66 371.47,1.6 C371.47,2.21 371.2,2.59 370.76,2.81 C371.25,3.03 371.56,3.44 371.56,4.14 C371.56,5.24 370.77,5.8 369.82,5.8 C368.87,5.8 368.11,5.31 368.08,4.2 L368.08,4.2 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "313.88 223.64 312.14 223.64 312.14 224.54 311.36 224.54 311.36 222.92 314.75 222.92 314.75 223.65 312.85 228.61 311.97 228.61 313.88 223.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.06,228.21 C315.76,227.91 315.66,227.53 315.63,227.12 L316.45,227.12 C316.51,227.62 316.77,227.91 317.28,227.91 C317.52,227.91 317.73,227.83 317.87,227.69 C318.11,227.45 318.14,227.07 318.14,226.69 C318.14,226.01 317.96,225.51 317.31,225.51 C316.85,225.51 316.59,225.74 316.5,226.02 L315.76,226.02 L315.76,222.91 L318.83,222.91 L318.83,223.64 L316.5,223.64 L316.5,225.14 C316.69,224.94 317.03,224.81 317.44,224.81 C317.89,224.81 318.23,224.95 318.46,225.18 C318.89,225.61 318.96,226.16 318.96,226.69 C318.96,227.3 318.9,227.79 318.48,228.2 C318.22,228.46 317.83,228.65 317.28,228.65 C316.73,228.65 316.31,228.46 316.07,228.21 L316.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "322.26 226.76 319.93 226.76 319.93 226 322.26 226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "325.82 223.64 324.08 223.64 324.08 224.54 323.3 224.54 323.3 222.92 326.69 222.92 326.69 223.65 324.79 228.61 323.91 228.61 325.82 223.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54,226.12 C329.39,226.21 329.2,226.24 329.01,226.24 C328.19,226.24 327.52,225.58 327.52,224.59 C327.52,223.54 328.21,222.85 329.2,222.85 C330.19,222.85 330.88,223.5 330.88,224.55 C330.88,224.94 330.78,225.3 330.49,225.91 L329.17,228.59 L328.29,228.59 L329.54,226.11 L329.54,226.12 Z M330.07,224.58 C330.07,223.96 329.73,223.59 329.21,223.59 C328.69,223.59 328.35,223.97 328.35,224.58 C328.35,225.14 328.67,225.56 329.21,225.56 C329.75,225.56 330.07,225.18 330.07,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.31,226.94 C272.31,226.55 272.41,226.19 272.71,225.58 L274.03,222.9 L274.9,222.9 L273.66,225.38 C273.81,225.29 274,225.26 274.18,225.26 C275,225.26 275.68,225.92 275.68,226.91 C275.68,227.96 274.99,228.65 274,228.65 C273.01,228.65 272.31,228 272.31,226.95 L272.31,226.94 Z M274.86,226.92 C274.86,226.36 274.53,225.94 273.99,225.94 C273.48,225.94 273.13,226.32 273.13,226.92 C273.13,227.52 273.48,227.91 273.99,227.91 C274.5,227.91 274.86,227.53 274.86,226.92 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.06,228.21 C276.76,227.91 276.66,227.53 276.63,227.12 L277.45,227.12 C277.51,227.62 277.77,227.91 278.28,227.91 C278.52,227.91 278.73,227.83 278.87,227.69 C279.11,227.45 279.14,227.07 279.14,226.69 C279.14,226.01 278.96,225.51 278.31,225.51 C277.85,225.51 277.59,225.74 277.5,226.02 L276.76,226.02 L276.76,222.91 L279.83,222.91 L279.83,223.64 L277.5,223.64 L277.5,225.14 C277.69,224.94 278.03,224.81 278.44,224.81 C278.89,224.81 279.23,224.95 279.46,225.18 C279.89,225.61 279.96,226.16 279.96,226.69 C279.96,227.3 279.9,227.79 279.48,228.2 C279.22,228.46 278.83,228.65 278.28,228.65 C277.73,228.65 277.31,228.46 277.07,228.21 L277.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "283.26 226.76 280.93 226.76 280.93 226 283.26 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.24,226.94 C284.24,226.55 284.34,226.19 284.64,225.58 L285.96,222.9 L286.83,222.9 L285.59,225.38 C285.74,225.29 285.93,225.26 286.11,225.26 C286.93,225.26 287.61,225.92 287.61,226.91 C287.61,227.96 286.92,228.65 285.93,228.65 C284.94,228.65 284.24,228 284.24,226.95 L284.24,226.94 Z M286.79,226.92 C286.79,226.36 286.46,225.94 285.92,225.94 C285.41,225.94 285.06,226.32 285.06,226.92 C285.06,227.52 285.41,227.91 285.92,227.91 C286.43,227.91 286.79,227.53 286.79,226.92 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.54,226.12 C290.39,226.21 290.2,226.24 290.01,226.24 C289.19,226.24 288.52,225.58 288.52,224.59 C288.52,223.54 289.21,222.85 290.2,222.85 C291.19,222.85 291.88,223.5 291.88,224.55 C291.88,224.94 291.78,225.3 291.49,225.91 L290.17,228.59 L289.29,228.59 L290.54,226.11 L290.54,226.12 Z M291.07,224.58 C291.07,223.96 290.73,223.59 290.21,223.59 C289.69,223.59 289.35,223.97 289.35,224.58 C289.35,225.14 289.67,225.56 290.21,225.56 C290.75,225.56 291.07,225.18 291.07,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,228.21 C233.5,227.91 233.4,227.53 233.37,227.12 L234.19,227.12 C234.25,227.62 234.51,227.91 235.02,227.91 C235.26,227.91 235.47,227.83 235.61,227.69 C235.85,227.45 235.88,227.07 235.88,226.69 C235.88,226.01 235.7,225.51 235.05,225.51 C234.59,225.51 234.33,225.74 234.24,226.02 L233.5,226.02 L233.5,222.91 L236.57,222.91 L236.57,223.64 L234.24,223.64 L234.24,225.14 C234.43,224.94 234.77,224.81 235.18,224.81 C235.63,224.81 235.97,224.95 236.2,225.18 C236.63,225.61 236.7,226.16 236.7,226.69 C236.7,227.3 236.64,227.79 236.22,228.2 C235.96,228.46 235.57,228.65 235.02,228.65 C234.47,228.65 234.05,228.46 233.81,228.21 L233.8,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,228.21 C237.76,227.91 237.66,227.53 237.63,227.12 L238.45,227.12 C238.51,227.62 238.77,227.91 239.28,227.91 C239.52,227.91 239.73,227.83 239.87,227.69 C240.11,227.45 240.14,227.07 240.14,226.69 C240.14,226.01 239.96,225.51 239.31,225.51 C238.85,225.51 238.59,225.74 238.5,226.02 L237.76,226.02 L237.76,222.91 L240.83,222.91 L240.83,223.64 L238.5,223.64 L238.5,225.14 C238.69,224.94 239.03,224.81 239.44,224.81 C239.89,224.81 240.23,224.95 240.46,225.18 C240.89,225.61 240.96,226.16 240.96,226.69 C240.96,227.3 240.9,227.79 240.48,228.2 C240.22,228.46 239.83,228.65 239.28,228.65 C238.73,228.65 238.31,228.46 238.07,228.21 L238.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "244.26 226.76 241.93 226.76 241.93 226 244.26 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.73,228.21 C245.43,227.91 245.33,227.53 245.3,227.12 L246.12,227.12 C246.18,227.62 246.44,227.91 246.95,227.91 C247.19,227.91 247.4,227.83 247.54,227.69 C247.78,227.45 247.81,227.07 247.81,226.69 C247.81,226.01 247.63,225.51 246.98,225.51 C246.52,225.51 246.26,225.74 246.17,226.02 L245.43,226.02 L245.43,222.91 L248.5,222.91 L248.5,223.64 L246.17,223.64 L246.17,225.14 C246.36,224.94 246.7,224.81 247.11,224.81 C247.56,224.81 247.9,224.95 248.13,225.18 C248.56,225.61 248.63,226.16 248.63,226.69 C248.63,227.3 248.57,227.79 248.15,228.2 C247.89,228.46 247.5,228.65 246.95,228.65 C246.4,228.65 245.98,228.46 245.74,228.21 L245.73,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.54,226.12 C251.39,226.21 251.2,226.24 251.01,226.24 C250.19,226.24 249.52,225.58 249.52,224.59 C249.52,223.54 250.21,222.85 251.2,222.85 C252.19,222.85 252.88,223.5 252.88,224.55 C252.88,224.94 252.78,225.3 252.49,225.91 L251.17,228.59 L250.29,228.59 L251.54,226.11 L251.54,226.12 Z M252.07,224.58 C252.07,223.96 251.73,223.59 251.21,223.59 C250.69,223.59 250.35,223.97 250.35,224.58 C250.35,225.14 250.67,225.56 251.21,225.56 C251.75,225.56 252.07,225.18 252.07,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,226.99 C355.24,226.31 355.62,225.9 356.02,225.66 C355.65,225.44 355.33,225.04 355.33,224.44 C355.33,223.49 356.06,222.86 356.99,222.86 C357.92,222.86 358.65,223.48 358.65,224.44 C358.65,225.04 358.33,225.44 357.96,225.66 C358.36,225.9 358.74,226.32 358.74,226.99 C358.74,228.02 357.96,228.65 356.98,228.65 C356,228.65 355.23,228.03 355.23,226.99 L355.24,226.99 Z M357.93,226.97 C357.93,226.44 357.52,226.02 356.99,226.02 C356.46,226.02 356.05,226.44 356.05,226.97 C356.05,227.5 356.46,227.91 356.99,227.91 C357.52,227.91 357.93,227.49 357.93,226.97 Z M357.84,224.45 C357.84,223.95 357.49,223.58 356.99,223.58 C356.49,223.58 356.15,223.96 356.15,224.45 C356.15,224.94 356.49,225.31 356.99,225.31 C357.49,225.31 357.84,224.95 357.84,224.45 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.06,228.21 C359.76,227.91 359.66,227.53 359.63,227.12 L360.45,227.12 C360.51,227.62 360.77,227.91 361.28,227.91 C361.52,227.91 361.73,227.83 361.87,227.69 C362.11,227.45 362.14,227.07 362.14,226.69 C362.14,226.01 361.96,225.51 361.31,225.51 C360.85,225.51 360.59,225.74 360.5,226.02 L359.76,226.02 L359.76,222.91 L362.83,222.91 L362.83,223.64 L360.5,223.64 L360.5,225.14 C360.69,224.94 361.03,224.81 361.44,224.81 C361.89,224.81 362.23,224.95 362.46,225.18 C362.89,225.61 362.96,226.16 362.96,226.69 C362.96,227.3 362.9,227.79 362.48,228.2 C362.22,228.46 361.83,228.65 361.28,228.65 C360.73,228.65 360.31,228.46 360.07,228.21 L360.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "365.9 226 367.24 226 367.24 226.76 365.9 226.76 365.9 228.1 365.14 228.1 365.14 226.76 363.8 226.76 363.8 226 365.14 226 365.14 224.67 365.9 224.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "196.44 227.74 194.14 227.74 194.14 226.98 196.15 222.9 197.03 222.9 195.03 226.98 196.45 226.98 196.45 225.65 197.24 225.65 197.24 226.98 197.85 226.98 197.85 227.74 197.24 227.74 197.24 228.6 196.45 228.6 196.45 227.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.06,228.21 C198.76,227.91 198.66,227.53 198.63,227.12 L199.45,227.12 C199.51,227.62 199.77,227.91 200.28,227.91 C200.52,227.91 200.73,227.83 200.87,227.69 C201.11,227.45 201.14,227.07 201.14,226.69 C201.14,226.01 200.96,225.51 200.31,225.51 C199.85,225.51 199.59,225.74 199.5,226.02 L198.76,226.02 L198.76,222.91 L201.83,222.91 L201.83,223.64 L199.5,223.64 L199.5,225.14 C199.69,224.94 200.03,224.81 200.44,224.81 C200.89,224.81 201.23,224.95 201.46,225.18 C201.89,225.61 201.96,226.16 201.96,226.69 C201.96,227.3 201.9,227.79 201.48,228.2 C201.22,228.46 200.83,228.65 200.28,228.65 C199.73,228.65 199.31,228.46 199.07,228.21 L199.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "205.26 226.76 202.93 226.76 202.93 226 205.26 226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "208.38 227.74 206.08 227.74 206.08 226.98 208.09 222.9 208.97 222.9 206.97 226.98 208.39 226.98 208.39 225.65 209.18 225.65 209.18 226.98 209.79 226.98 209.79 227.74 209.18 227.74 209.18 228.6 208.39 228.6 208.39 227.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.54,226.12 C212.39,226.21 212.2,226.24 212.01,226.24 C211.19,226.24 210.52,225.58 210.52,224.59 C210.52,223.54 211.21,222.85 212.2,222.85 C213.19,222.85 213.88,223.5 213.88,224.55 C213.88,224.94 213.78,225.3 213.49,225.91 L212.17,228.59 L211.29,228.59 L212.54,226.11 L212.54,226.12 Z M213.07,224.58 C213.07,223.96 212.73,223.59 212.21,223.59 C211.69,223.59 211.35,223.97 211.35,224.58 C211.35,225.14 211.67,225.56 212.21,225.56 C212.75,225.56 213.07,225.18 213.07,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,227.06 L156.02,227.06 C156.05,227.67 156.48,227.92 156.95,227.92 C157.48,227.92 157.88,227.58 157.88,226.98 C157.88,226.38 157.57,226.04 156.93,226.04 L156.79,226.04 L156.79,225.33 L156.93,225.33 C157.52,225.33 157.79,224.99 157.79,224.47 C157.79,223.89 157.41,223.59 156.95,223.59 C156.45,223.59 156.13,223.9 156.09,224.41 L155.27,224.41 C155.32,223.44 156.03,222.86 156.94,222.86 C157.91,222.86 158.6,223.51 158.6,224.45 C158.6,225.06 158.33,225.44 157.89,225.66 C158.38,225.88 158.69,226.3 158.69,227 C158.69,228.09 157.9,228.65 156.95,228.65 C156,228.65 155.24,228.16 155.21,227.05 L155.2,227.06 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,228.21 C159.76,227.91 159.66,227.53 159.63,227.12 L160.45,227.12 C160.51,227.62 160.77,227.91 161.28,227.91 C161.52,227.91 161.73,227.83 161.87,227.69 C162.11,227.45 162.14,227.07 162.14,226.69 C162.14,226.01 161.96,225.51 161.31,225.51 C160.85,225.51 160.59,225.74 160.5,226.02 L159.76,226.02 L159.76,222.91 L162.83,222.91 L162.83,223.64 L160.5,223.64 L160.5,225.14 C160.69,224.94 161.03,224.81 161.44,224.81 C161.89,224.81 162.23,224.95 162.46,225.18 C162.89,225.61 162.96,226.16 162.96,226.69 C162.96,227.3 162.9,227.79 162.48,228.2 C162.22,228.46 161.83,228.65 161.28,228.65 C160.73,228.65 160.31,228.46 160.06,228.21 L160.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "166.26 226.76 163.93 226.76 163.93 226 166.26 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.13,227.06 L167.95,227.06 C167.98,227.67 168.41,227.92 168.88,227.92 C169.41,227.92 169.81,227.58 169.81,226.98 C169.81,226.38 169.5,226.04 168.86,226.04 L168.72,226.04 L168.72,225.33 L168.86,225.33 C169.45,225.33 169.72,224.99 169.72,224.47 C169.72,223.89 169.34,223.59 168.88,223.59 C168.38,223.59 168.06,223.9 168.02,224.41 L167.2,224.41 C167.25,223.44 167.96,222.86 168.87,222.86 C169.84,222.86 170.53,223.51 170.53,224.45 C170.53,225.06 170.26,225.44 169.82,225.66 C170.31,225.88 170.62,226.3 170.62,227 C170.62,228.09 169.83,228.65 168.88,228.65 C167.93,228.65 167.17,228.16 167.14,227.05 L167.13,227.06 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.54,226.12 C173.39,226.21 173.2,226.24 173.01,226.24 C172.19,226.24 171.52,225.58 171.52,224.59 C171.52,223.54 172.21,222.85 173.2,222.85 C174.19,222.85 174.88,223.5 174.88,224.55 C174.88,224.94 174.78,225.3 174.49,225.91 L173.17,228.59 L172.29,228.59 L173.54,226.11 L173.54,226.12 Z M174.07,224.58 C174.07,223.96 173.73,223.59 173.21,223.59 C172.69,223.59 172.35,223.97 172.35,224.58 C172.35,225.14 172.67,225.56 173.21,225.56 C173.75,225.56 174.07,225.18 174.07,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.36,227.87 L118.55,225.21 C118.77,224.95 118.85,224.74 118.85,224.45 C118.85,223.94 118.55,223.59 118.02,223.59 C117.59,223.59 117.18,223.83 117.18,224.47 L116.36,224.47 C116.36,223.5 117.05,222.86 118.02,222.86 C118.99,222.86 119.67,223.48 119.67,224.46 C119.67,224.96 119.49,225.26 119.13,225.69 L117.35,227.87 L119.67,227.87 L119.67,228.6 L116.36,228.6 L116.36,227.87 L116.36,227.87 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.06,228.21 C120.76,227.91 120.66,227.53 120.63,227.12 L121.45,227.12 C121.51,227.62 121.77,227.91 122.28,227.91 C122.52,227.91 122.73,227.83 122.87,227.69 C123.11,227.45 123.14,227.07 123.14,226.69 C123.14,226.01 122.96,225.51 122.31,225.51 C121.85,225.51 121.59,225.74 121.5,226.02 L120.76,226.02 L120.76,222.91 L123.83,222.91 L123.83,223.64 L121.5,223.64 L121.5,225.14 C121.69,224.94 122.03,224.81 122.44,224.81 C122.89,224.81 123.23,224.95 123.46,225.18 C123.89,225.61 123.96,226.16 123.96,226.69 C123.96,227.3 123.9,227.79 123.48,228.2 C123.22,228.46 122.83,228.65 122.28,228.65 C121.73,228.65 121.31,228.46 121.06,228.21 L121.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "127.26 226.76 124.93 226.76 124.93 226 127.26 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,227.87 L130.49,225.21 C130.71,224.95 130.79,224.74 130.79,224.45 C130.79,223.94 130.49,223.59 129.96,223.59 C129.53,223.59 129.12,223.83 129.12,224.47 L128.3,224.47 C128.3,223.5 128.99,222.86 129.96,222.86 C130.93,222.86 131.61,223.48 131.61,224.46 C131.61,224.96 131.43,225.26 131.07,225.69 L129.29,227.87 L131.61,227.87 L131.61,228.6 L128.3,228.6 L128.3,227.87 L128.3,227.87 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54,226.12 C134.39,226.21 134.2,226.24 134.01,226.24 C133.19,226.24 132.52,225.58 132.52,224.59 C132.52,223.54 133.21,222.85 134.2,222.85 C135.19,222.85 135.88,223.5 135.88,224.55 C135.88,224.94 135.78,225.3 135.49,225.91 L134.17,228.59 L133.29,228.59 L134.54,226.11 L134.54,226.12 Z M135.07,224.58 C135.07,223.96 134.73,223.59 134.21,223.59 C133.69,223.59 133.35,223.97 133.35,224.58 C133.35,225.14 133.67,225.56 134.21,225.56 C134.75,225.56 135.07,225.18 135.07,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "78.88 223.79 77.77 224.77 77.77 223.87 78.88 222.91 79.7 222.91 79.7 228.6 78.88 228.6 78.88 223.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.06,228.21 C81.76,227.91 81.66,227.53 81.63,227.12 L82.45,227.12 C82.51,227.62 82.77,227.91 83.28,227.91 C83.52,227.91 83.73,227.83 83.87,227.69 C84.11,227.45 84.14,227.07 84.14,226.69 C84.14,226.01 83.96,225.51 83.31,225.51 C82.85,225.51 82.59,225.74 82.5,226.02 L81.76,226.02 L81.76,222.91 L84.83,222.91 L84.83,223.64 L82.5,223.64 L82.5,225.14 C82.69,224.94 83.03,224.81 83.44,224.81 C83.89,224.81 84.23,224.95 84.46,225.18 C84.89,225.61 84.96,226.16 84.96,226.69 C84.96,227.3 84.9,227.79 84.48,228.2 C84.22,228.46 83.83,228.65 83.28,228.65 C82.73,228.65 82.31,228.46 82.06,228.21 L82.06,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "88.26 226.76 85.93 226.76 85.93 226 88.26 226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "90.82 223.79 89.71 224.77 89.71 223.87 90.82 222.91 91.64 222.91 91.64 228.6 90.82 228.6 90.82 223.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54,226.12 C95.39,226.21 95.2,226.24 95.01,226.24 C94.19,226.24 93.52,225.58 93.52,224.59 C93.52,223.54 94.21,222.85 95.2,222.85 C96.19,222.85 96.88,223.5 96.88,224.55 C96.88,224.94 96.78,225.3 96.49,225.91 L95.17,228.59 L94.29,228.59 L95.54,226.11 L95.54,226.12 Z M96.07,224.58 C96.07,223.96 95.73,223.59 95.21,223.59 C94.69,223.59 94.35,223.97 94.35,224.58 C94.35,225.14 94.67,225.56 95.21,225.56 C95.75,225.56 96.07,225.18 96.07,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,228.21 C42.5,227.91 42.4,227.53 42.37,227.12 L43.19,227.12 C43.25,227.62 43.51,227.91 44.02,227.91 C44.26,227.91 44.47,227.83 44.61,227.69 C44.85,227.45 44.88,227.07 44.88,226.69 C44.88,226.01 44.7,225.51 44.05,225.51 C43.59,225.51 43.33,225.74 43.24,226.02 L42.5,226.02 L42.5,222.91 L45.57,222.91 L45.57,223.64 L43.24,223.64 L43.24,225.14 C43.43,224.94 43.77,224.81 44.18,224.81 C44.63,224.81 44.97,224.95 45.2,225.18 C45.63,225.61 45.7,226.16 45.7,226.69 C45.7,227.3 45.64,227.79 45.22,228.2 C44.96,228.46 44.57,228.65 44.02,228.65 C43.47,228.65 43.05,228.46 42.8,228.21 Z",
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "48.99 226.76 46.66 226.76 46.66 226 48.99 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.01,226.12 C51.86,226.21 51.67,226.24 51.48,226.24 C50.66,226.24 49.99,225.58 49.99,224.59 C49.99,223.54 50.68,222.85 51.67,222.85 C52.66,222.85 53.35,223.5 53.35,224.55 C53.35,224.94 53.25,225.3 52.96,225.91 L51.64,228.59 L50.76,228.59 L52.01,226.11 L52.01,226.12 Z M52.54,224.58 C52.54,223.96 52.2,223.59 51.68,223.59 C51.16,223.59 50.82,223.97 50.82,224.58 C50.82,225.14 51.14,225.56 51.68,225.56 C52.22,225.56 52.54,225.18 52.54,224.58 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38,227.02 L3.38,224.49 C3.38,223.47 4.12,222.86 5.02,222.86 C5.92,222.86 6.67,223.48 6.67,224.49 L6.67,227.02 C6.67,228.04 5.93,228.65 5.02,228.65 C4.11,228.65 3.38,228.03 3.38,227.02 Z M5.85,227 L5.85,224.52 C5.85,223.98 5.54,223.59 5.02,223.59 C4.5,223.59 4.2,223.97 4.2,224.52 L4.2,227 C4.2,227.54 4.51,227.93 5.02,227.93 C5.53,227.93 5.85,227.55 5.85,227 Z",
    id: "Shape",
    fill: "#678750",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "10.03 226.76 7.7 226.76 7.7 226 10.03 226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#678750",
    fillRule: "nonzero",
    points: "13.15 227.74 10.85 227.74 10.85 226.98 12.86 222.9 13.74 222.9 11.74 226.98 13.16 226.98 13.16 225.65 13.95 225.65 13.95 226.98 14.56 226.98 14.56 227.74 13.95 227.74 13.95 228.6 13.16 228.6 13.16 227.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "377.78 45.1 378.79 45.1 380.27 49.77 381.75 45.1 382.76 45.1 380.64 51.51 379.89 51.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.55,47.33 L385.86,48.02 C385.65,47.81 385.49,47.71 385.18,47.71 C384.68,47.71 384.27,48.11 384.27,48.74 L384.27,51.51 L383.35,51.51 L383.35,46.95 L384.25,46.95 L384.25,47.45 C384.48,47.13 384.95,46.9 385.46,46.9 C385.9,46.9 386.23,47.02 386.55,47.33 L386.55,47.33 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.08,47.43 C390.51,47.88 390.62,48.46 390.62,49.22 C390.62,49.98 390.51,50.57 390.08,51.02 C389.78,51.33 389.33,51.56 388.71,51.56 C388.09,51.56 387.65,51.33 387.35,51.02 C386.92,50.57 386.81,49.99 386.81,49.22 C386.81,48.45 386.92,47.88 387.35,47.43 C387.65,47.12 388.09,46.89 388.71,46.89 C389.33,46.89 389.78,47.12 390.08,47.43 Z M388.04,47.97 C387.76,48.25 387.73,48.73 387.73,49.22 C387.73,49.71 387.77,50.19 388.04,50.47 C388.21,50.64 388.44,50.74 388.71,50.74 C388.98,50.74 389.21,50.64 389.39,50.47 C389.67,50.19 389.7,49.71 389.7,49.22 C389.7,48.73 389.66,48.25 389.39,47.97 C389.22,47.8 388.98,47.71 388.71,47.71 C388.44,47.71 388.21,47.8 388.04,47.97 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.52,51.51 L394.62,51.51 L394.62,51.05 C394.3,51.39 393.86,51.56 393.4,51.56 C392.94,51.56 392.55,51.41 392.28,51.15 C391.93,50.81 391.82,50.38 391.82,49.86 L391.82,46.94 L392.74,46.94 L392.74,49.72 C392.74,50.43 393.15,50.74 393.66,50.74 C394.17,50.74 394.61,50.43 394.61,49.72 L394.61,46.94 L395.53,46.94 L395.53,51.5 L395.52,51.51 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "396.32 46.95 397.29 46.95 398.18 50.16 399.22 46.95 399.94 46.95 400.98 50.16 401.87 46.95 402.85 46.95 401.43 51.51 400.64 51.51 399.58 48.22 398.52 51.51 397.74 51.51 396.32 46.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.29,49.5 C404.29,50.29 404.7,50.78 405.45,50.78 C405.96,50.78 406.23,50.64 406.56,50.31 L407.14,50.86 C406.67,51.33 406.23,51.57 405.43,51.57 C404.29,51.57 403.38,50.97 403.38,49.23 C403.38,47.74 404.14,46.9 405.32,46.9 C406.5,46.9 407.26,47.78 407.26,49.11 L407.26,49.5 L404.3,49.5 L404.29,49.5 Z M406.22,48.24 C406.07,47.9 405.75,47.66 405.32,47.66 C404.89,47.66 404.56,47.89 404.41,48.24 C404.32,48.44 404.3,48.58 404.29,48.86 L406.34,48.86 C406.32,48.58 406.3,48.44 406.21,48.24 L406.22,48.24 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.72,47.31 C412.07,47.65 412.18,48.08 412.18,48.6 L412.18,51.52 L411.26,51.52 L411.26,48.74 C411.26,48.03 410.85,47.72 410.34,47.72 C409.83,47.72 409.39,48.03 409.39,48.74 L409.39,51.52 L408.47,51.52 L408.47,46.96 L409.37,46.96 L409.37,47.42 C409.68,47.08 410.13,46.91 410.58,46.91 C411.03,46.91 411.44,47.06 411.71,47.32 L411.72,47.31 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.86,
    y1: 56.75,
    x2: 412.86,
    y2: 56.75,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "387.06 23.75 386.09 23.75 386.09 19.46 384.61 22.58 383.89 22.58 382.38 19.46 382.38 23.75 381.41 23.75 381.41 17.34 382.38 17.34 384.25 21.33 386.09 17.34 387.06 17.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.98,20.7 L391.98,23.75 L391.08,23.75 L391.08,23.34 C390.75,23.67 390.43,23.81 389.86,23.81 C389.29,23.81 388.91,23.68 388.64,23.4 C388.41,23.16 388.28,22.81 388.28,22.42 C388.28,21.66 388.81,21.11 389.86,21.11 L391.06,21.11 L391.06,20.79 C391.06,20.2 390.78,19.93 390.06,19.93 C389.57,19.93 389.32,20.06 389.06,20.38 L388.47,19.81 C388.89,19.31 389.33,19.14 390.1,19.14 C391.36,19.14 391.98,19.68 391.98,20.71 L391.98,20.7 Z M390.01,21.74 C389.45,21.74 389.17,21.97 389.17,22.4 C389.17,22.83 389.43,23.05 390.03,23.05 C390.35,23.05 390.62,23.01 390.86,22.79 C391,22.66 391.06,22.44 391.06,22.12 L391.06,21.75 L390.01,21.75 L390.01,21.74 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,19.55 C396.98,19.89 397.09,20.32 397.09,20.84 L397.09,23.76 L396.17,23.76 L396.17,20.98 C396.17,20.27 395.76,19.96 395.25,19.96 C394.74,19.96 394.3,20.27 394.3,20.98 L394.3,23.76 L393.38,23.76 L393.38,19.2 L394.28,19.2 L394.28,19.66 C394.6,19.32 395.04,19.15 395.5,19.15 C395.96,19.15 396.36,19.3 396.62,19.56 L396.63,19.55 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.75,19.55 C402.1,19.89 402.21,20.32 402.21,20.84 L402.21,23.76 L401.29,23.76 L401.29,20.98 C401.29,20.27 400.88,19.96 400.37,19.96 C399.86,19.96 399.42,20.27 399.42,20.98 L399.42,23.76 L398.5,23.76 L398.5,19.2 L399.4,19.2 L399.4,19.66 C399.72,19.32 400.16,19.15 400.61,19.15 C401.06,19.15 401.47,19.3 401.74,19.56 L401.75,19.55 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.29,21.74 C404.29,22.53 404.7,23.02 405.45,23.02 C405.96,23.02 406.23,22.88 406.56,22.55 L407.14,23.1 C406.67,23.57 406.23,23.81 405.43,23.81 C404.29,23.81 403.38,23.21 403.38,21.47 C403.38,19.98 404.14,19.14 405.32,19.14 C406.5,19.14 407.26,20.02 407.26,21.35 L407.26,21.74 L404.3,21.74 L404.29,21.74 Z M406.22,20.48 C406.07,20.14 405.75,19.9 405.32,19.9 C404.89,19.9 404.56,20.13 404.41,20.48 C404.32,20.68 404.3,20.82 404.29,21.1 L406.34,21.1 C406.32,20.82 406.3,20.68 406.21,20.48 L406.22,20.48 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.72,19.55 C412.07,19.89 412.18,20.32 412.18,20.84 L412.18,23.76 L411.26,23.76 L411.26,20.98 C411.26,20.27 410.85,19.96 410.34,19.96 C409.83,19.96 409.39,20.27 409.39,20.98 L409.39,23.76 L408.47,23.76 L408.47,19.2 L409.37,19.2 L409.37,19.66 C409.69,19.32 410.13,19.15 410.58,19.15 C411.03,19.15 411.44,19.3 411.71,19.56 L411.72,19.55 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronischeZiektes);
export default __webpack_public_path__ + "static/media/chronische-ziektes.2086002110c5d76696b384d4e34d5da7.svg";
export { ForwardRef as ReactComponent };